import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface LocaleState {
  lang: string
}

const initialState: LocaleState = { lang: 'en' }

const localeSlice = createSlice({
  name: 'locale',
  initialState,
  reducers: {
    setLocale(state, action: PayloadAction<string>) {
      state.lang = action.payload
    },
  },
})

export const { setLocale } = localeSlice.actions
export default localeSlice.reducer
